import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArBH: CultureInfo = {
  name: 'ar-BH',
  displayName: 'Arabic (Bahrain)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-BH',
  parent: CultureInfoAr
};
